import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Logo').create(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '132px',
    maxWidth: '225px',

    img: {
      width: '100%',
      height: '100%',
    },
  },
}))
